import { styled as t, variants as l, css as i } from "@lokalise/styled";
import { value as n, typography as e, spacing as o } from "../../utils/theme/index.js";
import { Input as r } from "../Input/Input.js";
import { withLinkStyle as p } from "../../utils/styles/link.js";
const y = t.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`, m = t.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	font-family: ${n("font.family.default")};
`, v = t.div`
	width: 55px;
`, u = t(r)`
	min-width: 40px;
`, b = t.div`
	${e("body.caption.default")};
	padding: ${o(2)};
	color: ${n("color.text.light.default")};
`, h = t.div`
	${l(({ $visible: d }) => d ? "visible" : "hidden", {
  visible: i`
			visibility: visible;
		`,
  hidden: i`
			visibility: hidden;
		`
})}
`, x = t.button`
	${p};
	${e("body.caption.default")}
	border: none;
	padding-left: ${o(2)};
`;
export {
  x as Anchor,
  h as ButtonWrapper,
  y as Container,
  m as Content,
  v as InputWrapper,
  u as StyledInput,
  b as Text
};
//# sourceMappingURL=styles.js.map
